<template>
  <div
    class="d-flex justify-center"
  >
    <v-btn
      fab
      dark
      color="black"
      class="home-btn rounded-lg px-0"
      style="height:240px; width:480px; max-width:100%"
      :to="to"
      :href="href"
    >
      <div style="width:100%; height:144px; margin-left: -30px; margin-right: -30px">
        <div 
          class="rounded-t-lg d-flex align-center justify-center"
          style="height: 144px"
        >
          <v-icon 
            v-if="icon"
            size="96"
          >
            {{ icon }}
          </v-icon>
          <v-img
            contain
            v-else-if="img"
            :src="img"
            min-width="96"
            max-width="96"
            min-height="96"
            max-height="96"
          >
          </v-img>
        </div>
        <div
          class="white black--text pa-6 rounded-b-lg"
          style="height:96px; text-align:center"
        >
          <div class="font-weight-bold text-h5 mt-1 mb-3">{{ title }}</div>
          <div class="text-body-2" style="white-space:normal!important">
            <span>{{ instruction[0] }}</span>
            <span v-if="instruction.length" class="text-lowercase">{{ instruction.slice(1) }}</span>
          </div>
        </div>
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      default: '',
    },
    img: {
      default: '',
    },
    title: {
      required: true,
    },
    instruction: {
      default: '',
    },
    to: {
      default: '',
    },
    href: {
      default: '',
    }
  },
  // methods: {
  //   clickThisButton () {
  //     if (typeof this.url !== 'string' || !this.url) { return }
  //     this.$router.push(this.url)
  //       .catch(error => {
  //         if (error.name != "NavigationDuplicated") {
  //           throw error;
  //         }
  //       })
  //   }
  // },
}
</script>

<style lang="sass">
  .home-btn 
    align-items: start

    .v-btn__content
      width: 100%
</style>